
import { useState } from "react";
import { addPricesForm, addRolesForm } from "../../lib/actions";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AddPricesUi() {

    const nav = useNavigate();
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;


    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const result = await addPricesForm(new FormData(e.target), navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-8">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "Minimum distance" : "الحد الادنى للمسافة"} </label>
                    <input
                        type="number"
                        name="min_distance"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter minimum distance" : "أدخل الحد الادنى للمسافة"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "Maximum distance limit" : "الحد الاعلى للمسافة"} </label>
                    <input
                        type="number"
                        name="max_distance"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter maximum distance limit" : "أدخل الحد الاعلى للمسافة"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "Company's delivery fee" : "السعر"} </label>
                    <input
                        type="number"
                        name="company_price"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter company fee" : "أدخل سعر التوصيل للشركة"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "Delivery fee for the driver" : "السعر"} </label>
                    <input
                        type="number"
                        name="delivery_price"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter delivery fee" : "أدخل سعر التوصيل للسائق"}
                    />
                </div>
            </div>

            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};